import ModalCEWorkingCalendarFree from './ModalCEWorkingCalendarFree'
import { useMemo } from 'react'
import { WCalFreeModelType } from '@teinor/erp/types/company/WCalParent/WCal/WCalFree'
import { useLocation } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface WorkingCalendarFreeProps extends ComponentWithPermissions { }

const WorkingCalendarFree: React.FC<WorkingCalendarFreeProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('workingCalendarsFree', 'Calendarios de días festivos'),
        newText: t('newWorkingCalendarFree', 'Nuevo Calendario de Festivos'),
    }

    return (
        <BaseScreenTable TableComponent={TableWorkingCalendarFree} CreateModalComponent={ModalCEWorkingCalendarFree} EditModalComponent={ModalCEWorkingCalendarFree} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableWorkingCalendarFreeProps = TableComponentProps & {}

const TableWorkingCalendarFree: React.FC<TableWorkingCalendarFreeProps> = ({ setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const location = useLocation().pathname
    const year = useMemo(() => String(new Date().getFullYear()), [])
    const columns: ColumnTableSchema<WCalFreeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
    ]
    return (
        <TwinTableLink createRowDataLink={[location, ['$id', year]]} name='WorkingCalendarFree' columns={columns} getDataFrom='/api/app/workingCalendar/workingCalendarFree/getAllWorkingCalendarsFree' onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} />
    )
}

export default WorkingCalendarFree